export const ADS_LIST = 'ADS_LIST';
export const ADS_DETAIL = 'ADS_DETAIL';
export const ADS_PRODUCT_LIST = 'ADS_PRODUCT_LIST';
export const ADS_PRODUCT_DETAIL = 'ADS_PRODUCT_DETAIL';
export const REWARDS_LIST = 'REWARDS_LIST';
export const REWARDS_DETAIL = 'REWARDS_DETAIL';
